import { decimal, index, int, json, mysqlTable, text, timestamp, varchar, uniqueIndex } from "drizzle-orm/mysql-core";

/** Xero is the accounting authority; these are durable commands and reconciled snapshots. */
export const customerCreditNotes = mysqlTable("customer_credit_notes", {
  id: int("id").autoincrement().primaryKey(),
  requestKey: varchar("requestKey", { length: 64 }).notNull().unique(),
  requestHash: varchar("requestHash", { length: 64 }).notNull(),
  customerId: int("customerId").notNull(),
  number: varchar("number", { length: 80 }).notNull().unique(),
  sourceInvoiceRef: varchar("sourceInvoiceRef", { length: 80 }),
  sourceXeroInvoiceId: varchar("sourceXeroInvoiceId", { length: 64 }),
  sourceReference: varchar("sourceReference", { length: 255 }).notNull(),
  kind: varchar("kind", { length: 32 }).notNull(),
  reason: text("reason").notNull(),
  issueDate: varchar("issueDate", { length: 10 }).notNull(),
  amount: decimal("amount", { precision: 12, scale: 2 }).notNull(),
  remaining: decimal("remaining", { precision: 12, scale: 2 }).notNull().default("0.00"),
  currency: varchar("currency", { length: 3 }).notNull().default("SGD"),
  tenantId: varchar("tenantId", { length: 64 }).notNull(),
  xeroContactId: varchar("xeroContactId", { length: 64 }).notNull(),
  xeroCreditNoteId: varchar("xeroCreditNoteId", { length: 64 }),
  state: varchar("state", { length: 32 }).notNull().default("pending"),
  payload: json("payload").$type<Record<string, unknown>>().notNull(),
  lastError: text("lastError"),
  createdByUserId: int("createdByUserId").notNull(),
  createdAt: timestamp("createdAt").notNull().defaultNow(),
  refreshedAt: timestamp("refreshedAt"),
}, (t) => ({
  customerIdx: index("credit_customer_idx").on(t.customerId),
  sourceIdx: index("credit_source_idx").on(t.sourceXeroInvoiceId),
  xeroUid: uniqueIndex("credit_xero_uid").on(t.tenantId, t.xeroCreditNoteId),
}));

export const customerCreditOperations = mysqlTable("customer_credit_operations", {
  id: int("id").autoincrement().primaryKey(),
  requestKey: varchar("requestKey", { length: 64 }).notNull().unique(),
  requestHash: varchar("requestHash", { length: 64 }).notNull(),
  creditNoteId: int("creditNoteId").notNull(),
  invoiceRef: varchar("invoiceRef", { length: 80 }).notNull(),
  xeroInvoiceId: varchar("xeroInvoiceId", { length: 64 }).notNull(),
  amount: decimal("amount", { precision: 12, scale: 2 }).notNull(),
  kind: varchar("kind", { length: 20 }).notNull().default("apply"),
  state: varchar("state", { length: 32 }).notNull().default("pending"),
  baselineAllocationIds: json("baselineAllocationIds").$type<string[]>().notNull(),
  xeroAllocationId: varchar("xeroAllocationId", { length: 64 }),
  lastError: text("lastError"),
  createdByUserId: int("createdByUserId").notNull(),
  createdAt: timestamp("createdAt").notNull().defaultNow(),
  completedAt: timestamp("completedAt"),
}, (t) => ({ invoiceIdx: index("credit_operation_invoice_idx").on(t.invoiceRef) }));

export const customerCreditAudit = mysqlTable("customer_credit_audit", {
  id: int("id").autoincrement().primaryKey(),
  creditNoteId: int("creditNoteId").notNull(),
  operationId: int("operationId"),
  event: varchar("event", { length: 64 }).notNull(),
  actorUserId: int("actorUserId").notNull(),
  details: json("details").$type<Record<string, unknown>>().notNull(),
  createdAt: timestamp("createdAt").notNull().defaultNow(),
});
